export default __webpack_public_path__ + "/src/assets/images/ezgif.com-gif-maker.gif";